let idCounter = 0

// Generate unique ids for elements
export const uniqueId = () => (idCounter += 1)
